import { render, staticRenderFns } from "./groupBulkShelves.vue?vue&type=template&id=78d2de16&scoped=true"
import script from "./groupBulkShelves.vue?vue&type=script&lang=js"
export * from "./groupBulkShelves.vue?vue&type=script&lang=js"
import style0 from "./groupBulkShelves.vue?vue&type=style&index=0&id=78d2de16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d2de16",
  null
  
)

export default component.exports